// ? Login module routes
import { RouteNames } from '@/router/routeNames';
import BiometricsPrompt from './biometrics/BiometricsPrompt.vue';
import PolicyAcknowledgementAction from './policyacknowledgement/PolicyAcknowledgementAction.vue';
import TermsOfUseModal from './termsofuse/TermsOfUseModal.vue';
import type { RouteRecordRaw } from 'vue-router';
import { useGlobalStore } from '@/stores/global/global.store';
import SuccessBiometrics from './biometrics/SuccessBiometrics.vue';
import ErrorBiometrics from './biometrics/ErrorBiometrics.vue';

const routes: RouteRecordRaw = {
  name: RouteNames.BOOTSTRAP_TASKS,
  path: 'tasks',
  meta: {
    pageTitle: 'Landing.BootstrapTasks',
  },
  children: [
    {
      name: RouteNames.BIOMETRICS_SPLASH,
      path: 'biometricsSplash',
      component: BiometricsPrompt,
    },
    {
      name: RouteNames.SUCCESS_BIOMETRICS,
      path: 'SuccessBiometrics',
      component: SuccessBiometrics,
    },
    {
      name: RouteNames.ERROR_BIOMETRICS,
      path: 'ErrorBiometrics',
      component: ErrorBiometrics,
    },
    {
      name: RouteNames.POLICY_ACKNOWLEDGEMENT,
      path: 'policyAcknowledgement',
      component: PolicyAcknowledgementAction,
      beforeEnter: (_to, _from) => {
        const globalStore = useGlobalStore();
        if (!globalStore.hasPolicyAckTask) {
          // cancel the current navigation if no tasks for PolicyAck.
          // If the browser URL was changed (either manually by the user or via back button),
          // it will be reset to that of the from route.
          if (!_from.name && !_from.matched.length) return { name: RouteNames.DASHBOARD };
          return false;
        }
      },
    },
    {
      name: RouteNames.TERMS_OF_USE,
      path: 'termsOfUse',
      component: TermsOfUseModal,
      beforeEnter: (_to, _from) => {
        const globalStore = useGlobalStore();
        if (!globalStore.hasTermsOfUseTask) {
          // cancel the current navigation if no tasks for TermsOfUse.
          // If the browser URL was changed (either manually by the user or via back button),
          // it will be reset to that of the from route.
          if (!_from.name && !_from.matched.length) return { name: RouteNames.DASHBOARD };
          return false;
        }
      },
    },
  ],
};

export default routes;
